import { all, takeLatest } from 'redux-saga/effects';
import * as retailersGroupsActions from '../actions';
import fetchRetailersGroups from './worker.fetchRetailersGroups';

function* retailersGroupsSaga() {
  yield all([takeLatest([retailersGroupsActions.fetchRetailersGroups.type], fetchRetailersGroups)]);
}

export default retailersGroupsSaga;
